import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { APIType } from 'src/app/config/constant';
import { z } from 'zod';
import { Country } from '../model/api';
import { ApiHttpService } from './apihttp.service';
import { BillAcceptorService } from './components/billacceptor.service';
import { StorageService } from './storage.service';
import { UiService } from './ui.service';
import { BillDispenserService } from './components/billdispenser.service';

export type ESTIMATE_FEE = { sending_fee: string, transaction_fee: string, vat: string, receivers_amount: string, total_due: string }
export type CUSTOMER_INFO = {
  id: string,
  // card_ref_number: string,
  // card_prefix: string,
  // card_number: string,
  // expiry_date: string,
  // cvv_code: string,
  // card_type_id: string,
  // card_balance: string,
  mobile_number: string,
  // card_status_id: string,
  // client_id: string,
  // rawcard: string,
  first_name: string,
  last_name: string,
  // middle_name: string,
  // email: string,
  // gender: string,
  // mobile: string,
  // pin: string,
  // country: string,
  // state1: string,
  // city: string,
  // birthday: string,
  address1: string,
  // address2: string,
  // zip: string,
  // status: string,
  // verification_code: string | null,
  // created_by: string | null,
  // create_on: string,
  // updated_by: string,
  // updated_on: string,
  // merchant_id: string,
  // ezkard_account_id: string,
  // mobile_number_state: string | null,
  // mobile_number_state_status: string | null,
  // image_url: string,
  // mywallet_customerid: string,
  // communication_preference: string | null,
  // customer_access: string,
  // nib_number: string | null,
  // island: string,
  // po_box: string | null,
  // success_ans_count: string | null,
  // wrong_ans_count: string | null,
  // time_refresh_answer: string | null,
  // id_card_type: string,
  id_card_num: string,
  // id_card_expiry: string,
  // id_card_url: string | null,
  id_type_desc: string,
  // signature: string,
  // scanned_id: string,
  // occupation: string,
  // employment_position_level: string,
  // has_secondary_id: string,
  // is_wu_user: string,
  // wu_terms_condtion: string,
  // is_bahamian: string,
  // reward_identifier: string,
  // sms_notification: string,
  // email_notification: string,
  // referredby_id: string,
  // reason_reject: string | null,
  // is_sound_on: string,
  // customer_tag: string,
  // cash_advance_customer_key: string | null,
  // cash_advance_registration_status: string,
  // wu_terms_condition: string,
  // selfie_url: string,
  // ios_vr: string | null,
  // android_vr: string,
  // my_wu_card_number: string,
  // nationality: string,
  // postal_code: string,
  // compliance_issue_date: string,
  // compliance_has_issue_date: string,
  compliance_issue_country_code: string,
  // compliance_issue_country_name: string,
  // compliancedd_issue_state: string,
  // compliance_country_birth: string,
  compliance_alpha_type_code: string,
  compliance_is_resident: string,
  // status_compliance: string,
  // risk_rating: string,
  // referral_counter: string | null,
  // is_eligible_for_referal_promo: string,
  // earnings: string,
  // popid_token: string | null,
  // is_compliance_reupload: string,
  // app_data: string,
  // is_pinoywallet: string,
  // is_new: string,
  // is_locked: string,
  // login_tries: string,
  // suncash_bank_account: string,
  // ip_address_upon_reg: string,
  // country_upon_reg: string,
  // id_card_issue_date: string,
  // customer_id: string,
  KYC_Status: string,
  compliance_issue_currency_code: string
}

type WU_PRODUCT_TYPE = {
  name: "MONEY IN MINUTES",
  code: "000",
  type: "WMN",
  routing_code: string,
} | {
  name: "DIRECT TO BANK - SAME/NEXT DAY",
  code: "500",
  type: "WMN",
  routing_code: string
}
type WU_PRODUCT = {
  wu_product: WU_PRODUCT_TYPE,
  transaction_type: string,
  payment_details: WU_PAYMENT_DETAILS
}
type WU_PARTNER = {
  id: string,
  system: {
    id: string,
    name: string,
    version: string,
    ip_address: string,
    connector: {
      id: string,
    }
  }
}
type WU_DEVICE = {
  id: string,
  type: string,
}
type WU_SENDER = {
  name: {
    first_name: string,
    last_name: string,
  },
  address: {
    addr_line1: string,
    addr_line2: string[],
    city: string,
    state: string,
    postal_code: string[],
    country_iso_code: string,
    locale: string[]
  }
}
type WU_RECEIVER = {
  name: {
    first_name: string,
    last_name: string,
  },
  address: {
    addr_line1: string,
    addr_line2: string[],
    city: string,
    state: string | string[],
    postal_code: string[],
    country_iso_code: string,
    address_type?: string,
  },
  email?: string,
  mobile_phone: {
    phone_number: any[],
    identity: unknown
  },
  mobile_details: any[]
}
type WU_PAYMENT_DETAILS = {
  origination: {
    principal_amount: string,
    gross_amount: string,
    currency_iso_code: string,
    country_iso_code: string,
  },
  destination: {
    expected_payout_amount: string,
    actual_payout_amount?: string,
    currency_iso_code: string,
    country_iso_code: string,
    state_code: string | string[],
    city: string,
  },
  promotion?: {
    code?: string,
    discount: string,
    status: string,
  },
  taxes: {
    tax_amount: string,
    municipal_tax: string,
    state_tax: string,
    county_tax?: string,
  },
  fees: {
    delivery_charges: string,
    other_charges: string,
    charges: string,
  },
  message_charges?: unknown[],
  exchange_rate?: string,
  payment_digest?: string,
}
export type FEE_INQUIRY = {
  Body: {
    "esp-fee-inquiry-reply": {
      partner: WU_PARTNER,
      device: WU_DEVICE,
      external_reference_no: string,
      sender: {
        Is_a_resident: string,
      },
      service_options: {
        service_option: WU_PRODUCT[],
      },
      test_question_flag: string,
    }
  }
}
export type TRANSACTION_INQUIRY = {
  Body: {
    "esp-transaction-inquiry-reply": {
      partner: WU_PARTNER,
      device: WU_DEVICE,
      external_reference_no: string,
      sender: WU_SENDER,
      receiver: WU_RECEIVER,
      payment_details: WU_PAYMENT_DETAILS,
      transaction_id: string,
      money_transfer_control: {
        date: string,
        mtcn: string,
      },
      txn_status_label: string,
      txn_status_description: string,
    }
  }
}
/**
 * @id receiver's id
 * @customer_id sender's id
 */
export type RECEIVER = {
  id: string,
  customer_id: string,
  receiver_firstname: string,
  receiver_lastname: string,
  receiver_middlename: string,
  receiver_mobile: string,
  relationship_sender_to_receiver: string,
  address: string,
  city: string,
  state_province: string,
  country: string,
  country_code: string,
  status: string,
  id_image: string | null,
  id_number: string | null,
  id_type: string | null,
  id_expiry: string | null,
  receiver_compliance_status: string,
  created_date: string,
  is_blacklisted: string,
}

export type PURPOSE = {
  id: string,
  description: string,
  status: string,
}
export type SOURCE = {
  id: string,
  description: string,
}
export type RELATION = {
  id: string,
  description: string,
}
export type NewReceiver = {
  firstName: string,
  lastName: string,
  mobile: string,
  address: string,
  country: string,
  countryCode: string,
  relationship: string,
  city: string,
  state: string,
  middleName: string,
}

export type SEND_MONEY_STORE_REPLY = {
  Body: {
    "esp-send-money-store-reply": {
      partner: WU_PARTNER,
      device: WU_DEVICE,
      external_reference_no: string,
      informational_messages: {
        informational_message: string[],
      },
      sender: WU_SENDER,
      receiver: WU_RECEIVER,
      wu_product: WU_PRODUCT_TYPE,
      transaction_type: "WMN",
      payment_details: Omit<WU_PAYMENT_DETAILS, "fees"> & {
        fees: {
          base_charges: string,
          delivery_charges: string,
          other_charges: string
        }
      },
      new_points_earned: string,
      transaction_id: string,
      money_transfer_control: {
        date: string,
        mtcn: string,
      },
      date_time: string
    }
  },
  TransactionId: string,
}

export type RECEIVE_MONEY_REPLY = {
  Body: {
    "esp-pickup-receive-reply": {
      partner: WU_PARTNER,
      device: WU_DEVICE,
      external_reference_no: string,
      sender: WU_SENDER,
      receiver: WU_RECEIVER,
      payment_details: WU_PAYMENT_DETAILS,
      transaction_id: string,
      money_transfer_control: {
        date: string,
        mtcn: string,
      },
      status: {
        code: string,
        message: string,
        reference_no: string,
      },
      date_time: string,
    }
  }
}

export const WU_END_POINT: {
  HEART_BEAT: APIType<{ session: string }, { Status: { code: string, message: string, }, SendMoney: "AVAILABLE" | "UNAVAILABLE", ReceiveMoney: "AVAILABLE" | "UNAVAILABLE" }>,
  CALCULATE_PRICE: APIType<{ session: string, amount: number, include_fee: 1 | 0 }, ESTIMATE_FEE>,
  FEE_INQUIRY: APIType<{ session: string, wuFeeTransactionType: string, originationPrincipalAmount: number, originationCurrencyCode: string, originationCountryCode: string, destinationExpectedPayoutAmount: number, destinationCurrencyCode: string, destinationCountryCode: string, complianceIsResident: string, wuPromo: string, destinationCity: string }, FEE_INQUIRY>,
  CUSTOMER_INFO: APIType<{ session: string, mobile: string }, CUSTOMER_INFO>,
  TRANSACTION_INQUIRY: APIType<{ session: string, firstname: string, lastname: string, mtcn: string }, TRANSACTION_INQUIRY>,
  GET_RECEIVER: APIType<{ session: string, customerId: string }, RECEIVER[]>,
  GET_PURPOSE: APIType<{ session: string, isResident: string, residencyType: string }, PURPOSE[]>,
  GET_SOURCE: APIType<{ session: string }, SOURCE[]>,
  GET_RELATION: APIType<{ session: string }, RELATION[]>,
  ADD_RECEIVER: APIType<{ session: string, customerId: string, } & NewReceiver, any>,
  DELETE_RECEIVER: APIType<{ session: string, receiverId: string, }, any>,
  GENERATE_KYC_QR: APIType<{ session: string }, string>,
  GENERATE_RECEIVER_QR: APIType<{ session: string }, string>,
  SEND_KYC_SMS: APIType<{ session: string, mobile: string }, string>,
  SEND_RECEIVER_SMS: APIType<{ session: string, mobile: string }, string>,
  SEND_MONEY: APIType<{ session: string, customerId: string, amount: string, receiverId: string, source: string, purpose: string, question: string, answer: string }, SEND_MONEY_STORE_REPLY>,
  COMPUTE_SEND_AMOUNT: APIType<{ session: string, customerId: string, amount: string, receiverId: string, }, string>,
  RECEIVE_MONEY: APIType<{ session: string, customerId: string, mtcn: string, purpose: string, source: string, answer: string, }, RECEIVE_MONEY_REPLY>,
} = {
  HEART_BEAT: { method: 'heartBeat', params: { session: 'P01', }, },
  CALCULATE_PRICE: { method: 'wuCalculatePrice', params: { session: 'P01', amount: 'P02', include_fee: 'P03' }, },
  FEE_INQUIRY: {
    method: 'feeInquiry', params: {
      session: 'P01', wuFeeTransactionType: 'P02', originationPrincipalAmount: 'P03', originationCurrencyCode: 'P04', originationCountryCode: 'P05', destinationExpectedPayoutAmount: 'P06', destinationCurrencyCode: 'P07', destinationCountryCode: 'P08', complianceIsResident: 'P09', wuPromo: 'P10', destinationCity: 'P11'
    },
  },
  CUSTOMER_INFO: { method: 'getCustomerInfoByMobile', params: { session: 'P01', mobile: 'P02' }, },
  TRANSACTION_INQUIRY: { method: 'wuTransactionInquiry', params: { session: 'P01', firstname: 'P02', lastname: 'P03', mtcn: 'P04' }, },
  GET_RECEIVER: { method: 'wuGetReceiver', params: { session: 'P01', customerId: 'P02' } },
  GET_PURPOSE: { method: 'getWuPurposeOfTransaction', params: { session: 'P01', isResident: 'P02', residencyType: 'P03' } },
  GET_SOURCE: { method: 'getWuSourceOfFunds', params: { session: 'P01' } },
  GET_RELATION: { method: 'getRelationship', params: { session: 'P01' } },
  ADD_RECEIVER: { method: 'wuAddReceiver', params: { session: 'P01', customerId: 'P02', firstName: "P03", lastName: 'P04', mobile: 'P05', address: 'P06', country: 'P07', countryCode: 'P08', relationship: 'P09', city: 'P10', state: 'P11', middleName: 'P12' } },
  DELETE_RECEIVER: { method: 'wuDeleteReceiver', params: { session: 'P01', receiverId: 'P02' } },
  GENERATE_KYC_QR: { method: 'generateWuKycQr', params: { session: 'P01' } },
  GENERATE_RECEIVER_QR: { method: 'generateWuReceiverQr', params: { session: 'P01' } },
  SEND_KYC_SMS: { method: 'sendSmsKyc', params: { session: 'P01', mobile: 'P02' } },
  SEND_RECEIVER_SMS: { method: 'sendSmsReceiver', params: { session: 'P01', mobile: 'P02' } },
  SEND_MONEY: { method: 'kioskWuSendMoney', params: { session: 'P01', customerId: 'P02', amount: 'P03', receiverId: 'P04', source: 'P05', purpose: 'P06', question: 'P07', answer: 'P08' } },
  COMPUTE_SEND_AMOUNT: { method: 'wuCalculateAmount', params: { session: 'P01', customerId: 'P02', amount: 'P03', receiverId: 'P04', } },
  RECEIVE_MONEY: { method: 'kioskWuReceiveMoney', params: { session: 'P01', customerId: 'P02', mtcn: 'P03', purpose: 'P04', source: 'P05', answer: 'P06', } },
} as const

@Injectable({
  providedIn: 'root'
})
export class WesternUnionService {
  newReceiver$ = new BehaviorSubject({
    firstName: '',
    lastName: '',
    mobile: '',
    address: '',
    country: '',
    countryCode: '',
    relationship: '',
    city: '',
    state: '',
    middleName: ''
  })

  constructor(public api: ApiHttpService, public storage: StorageService, public billAcceptor: BillAcceptorService, public ui: UiService, public billDispenser: BillDispenserService) { }

  getHeartBeat() {
    let session = this.storage.get('user.SessionID')
    return this.api.post(WU_END_POINT.HEART_BEAT, { session }).then((response) => {
      if (response.data.Status.code == "0000") {
        return response;
      } else {
        return Promise.reject(response)
      }
    })
  }

  estimateFee(amount: number, cancelOld: boolean = true) {
    let session = this.storage.get('user.SessionID')
    return [this.api, this.api.cancelOld(WU_END_POINT.CALCULATE_PRICE)][Number(cancelOld)]
      .post(WU_END_POINT.CALCULATE_PRICE, { session, amount, include_fee: 1 })
  }

  feeInquiry(params: {
    originationPrincipalAmount: number, originationCurrencyCode: string, originationCountryCode: string,
    destinationExpectedPayoutAmount: number, destinationCurrencyCode: string, destinationCountryCode: string,
    complianceIsResident: string
  }) {
    let session = this.storage.get('user.SessionID')
    return this.api.cancelOld(WU_END_POINT.FEE_INQUIRY).post(WU_END_POINT.FEE_INQUIRY, {
      session,
      ...params,
      wuFeeTransactionType: 'WMN',
      wuPromo: '',
      destinationCity: ''
    }).then((response) => {
      if (!Array.isArray(response.data.Body['esp-fee-inquiry-reply'].service_options.service_option)) {
        response.data.Body['esp-fee-inquiry-reply'].service_options.service_option = [response.data.Body['esp-fee-inquiry-reply'].service_options.service_option]
      }
      return response
    })
  }

  customerInfo(mobile: string, mute = true) {
    let session = this.storage.get('user.SessionID')
    return this.api.mute(mute).post(WU_END_POINT.CUSTOMER_INFO, { session, mobile, })
  }

  async getReceivers() {
    let session = this.storage.get('user.SessionID')
    let customerId = this.storage.get('wu.customer.id');
    let countries = await this.api.getCountries();

    return this.api.post(WU_END_POINT.GET_RECEIVER, { session, customerId }).then((response) => {
      return response.data.map((receiver) => {
        const flag = countries.find(country => country.code2 == receiver.country_code)?.flag || '';
        return { ...receiver, flag }
      })
    }).catch((e) => [])
  }

  getPurpose() {
    let session = this.storage.get('user.SessionID')
    let customer = this.storage.get('wu.customer')
    let isResident = customer.compliance_is_resident;
    let residencyType = customer.compliance_alpha_type_code;
    return this.api.post(WU_END_POINT.GET_PURPOSE, { session, isResident, residencyType }).then((response) => {
      return response.data.filter(i => i.status == "A")
    }).catch((e) => [])
  }

  getSource() {
    let session = this.storage.get('user.SessionID')
    return this.api.post(WU_END_POINT.GET_SOURCE, { session }).then((response) => {
      return response.data
    }).catch((e) => [])
  }

  getRelations() {
    let session = this.storage.get('user.SessionID')
    return this.api.post(WU_END_POINT.GET_RELATION, { session }).then((response) => {
      return response.data
    }).catch((e) => [])
  }

  addReceiver() {
    let session = this.storage.get('user.SessionID')
    let customer = this.storage.get('wu.customer')
    let receiver = this.newReceiver$.value
    // console.log({ session, customer, receiver });
    return this.api.post(WU_END_POINT.ADD_RECEIVER, { session, customerId: customer.id, ...receiver })
  }

  deleteReceiver(receiverId: string) {
    let session = this.storage.get('user.SessionID')
    return this.api.post(WU_END_POINT.DELETE_RECEIVER, { session, receiverId })
  }

  generateKycQR() {
    let session = this.storage.get('user.SessionID')
    return this.api.post(WU_END_POINT.GENERATE_KYC_QR, { session })
  }

  generateReceiverQR() {
    let session = this.storage.get('user.SessionID')
    return this.api.post(WU_END_POINT.GENERATE_RECEIVER_QR, { session })
  }

  sendReceiverSMS(mobile: string) {
    let session = this.storage.get('user.SessionID')
    return this.api.post(WU_END_POINT.SEND_RECEIVER_SMS, { session, mobile })
  }

  sendKycSMS(mobile: string) {
    let session = this.storage.get('user.SessionID')
    return this.api.post(WU_END_POINT.SEND_KYC_SMS, { session, mobile })
  }

  sendMoney(params: { amount: string, source: string, purpose: string }) {
    let session = this.storage.get('user.SessionID')
    let customer = this.storage.get('wu.customer')
    let receiver = this.storage.get('wu.receiver')
    let data = {
      session,
      amount: params.amount,
      customerId: customer.id,
      receiverId: receiver.id,
      source: params.source,
      purpose: params.purpose,
      question: '',
      answer: '',
    }
    this.billAcceptor.getTxDenominations()
      .then((tx_denominations) => {
        this.api.ztrail(
          this.api.processParams(WU_END_POINT.SEND_MONEY, data),
          {
            transaction_type: 'WU_SEND',
            ...tx_denominations
          }
        )
      })
    return this.api.mute().post(WU_END_POINT.SEND_MONEY, data)
  }

  getFees(amount: number) {
    let customer = this.storage.get('wu.customer')
    let receiver = this.storage.get('wu.receiver')
    // let destination = { currency_code: "USD", country_code: "US" }
    let destination = this.storage.get('countries').find(i => i.code2 == receiver.country_code) as z.infer<typeof Country>;
    // console.log(destination, receiver, customer)
    this.api.mute(false)
    return Promise.all([
      this.feeInquiry({
        originationPrincipalAmount: Math.round(amount * 100), originationCurrencyCode: customer.compliance_issue_currency_code, originationCountryCode: customer.compliance_issue_country_code,
        destinationExpectedPayoutAmount: 0, destinationCurrencyCode: destination.currency_code, destinationCountryCode: destination.code,
        complianceIsResident: customer.compliance_is_resident
      }),
      this.estimateFee(amount)
    ])
      .then((response) => {
        this.storage.set('wu.send.fees', response[0].data)
        this.storage.set('wu.send.price', response[1].data)
        this.ui.action$.next({
          name: 'SET_DEPOSIT_FEE',
          data: { fees: response[0].data, price: response[1].data }
        });
      })
  }

  computeAmount(amount: string) {
    let session = this.storage.get('user.SessionID')
    let customer = this.storage.get('wu.customer')
    let receiver = this.storage.get('wu.receiver')
    let data = {
      session,
      amount,
      customerId: customer.id,
      receiverId: receiver.id,
    }
    return this.api.cancelOld(WU_END_POINT.COMPUTE_SEND_AMOUNT).mute(false).post(WU_END_POINT.COMPUTE_SEND_AMOUNT, data).then(async (response) => {
      let sendAmount = Number(response.data)
      if (sendAmount >= Number(amount)) {
        return 0;
      }
      await this.getFees(sendAmount)
      return sendAmount;
    }).catch(async () => {
      return 0;
      /*
      let TEST_AMOUNT = 1;
      let cash = Number(amount);
      await this.getFees(TEST_AMOUNT)
      let price = this.storage.get('wu.send.price')
      let fees = this.storage.get('wu.send.fees')
      let feeData = fees.Body['esp-fee-inquiry-reply']
      let gross_amount = Number(feeData.service_options.service_option[0].payment_details.origination.gross_amount) / 100;
      let suncashFee = Number(price.transaction_fee) + Number(price.vat);
      let topay = gross_amount + suncashFee;

      let minFee = topay - TEST_AMOUNT;
      let sendAmount = cash - minFee;
      let cents = [0.01, 0.05, 0.10, 0.25, 0.50];
      let dollars = [1, 5, 10, 20, 50, 100];
      if (sendAmount > 0) {
        this.storage.set('ui.deposit.cash', sendAmount);
        await this.getFees(sendAmount > 0 ? sendAmount : TEST_AMOUNT)
        price = this.storage.get('wu.send.price')
        fees = this.storage.get('wu.send.fees')
        feeData = fees.Body['esp-fee-inquiry-reply']
        gross_amount = Number(feeData.service_options.service_option[0].payment_details.origination.gross_amount) / 100;
        suncashFee = Number(price.transaction_fee) + Number(price.vat);
        topay = gross_amount + suncashFee;

        while (sendAmount > 0 && cash < topay) {
          let a = cents.concat(dollars)
          let dec = (a.filter((i) => i <= (topay - cash)).pop()) || a[0]
          sendAmount -= dec;
          this.storage.set('ui.deposit.cash', sendAmount);
          await this.getFees(sendAmount)
          price = this.storage.get('wu.send.price')
          fees = this.storage.get('wu.send.fees')
          feeData = fees.Body['esp-fee-inquiry-reply']
          gross_amount = Number(feeData.service_options.service_option[0].payment_details.origination.gross_amount) / 100;
          suncashFee = Number(price.transaction_fee) + Number(price.vat);
          topay = gross_amount + suncashFee;
        }

        while (cash > topay) {
          let inc = (cents.filter((i) => i <= (cash - topay)).pop()) || cents[0]
          sendAmount += inc;
          this.storage.set('ui.deposit.cash', sendAmount);
          await this.getFees(sendAmount)
          price = this.storage.get('wu.send.price')
          fees = this.storage.get('wu.send.fees')
          feeData = fees.Body['esp-fee-inquiry-reply']
          gross_amount = Number(feeData.service_options.service_option[0].payment_details.origination.gross_amount) / 100;
          suncashFee = Number(price.transaction_fee) + Number(price.vat);
          topay = gross_amount + suncashFee;
        }
      }
      return sendAmount; */
    })
  }

  transactionInquiry(mtcn: string) {
    let receiver = this.storage.get('wu.customer');
    let session = this.storage.get('user.SessionID');
    return this.api.mute().post(WU_END_POINT.TRANSACTION_INQUIRY, {
      session,
      firstname: receiver.first_name,
      lastname: receiver.last_name,
      mtcn
    }).then((response) => {
      if (!["USD", "BSD"].includes(response.data.Body['esp-transaction-inquiry-reply'].payment_details.destination.currency_iso_code)) {
        return Promise.reject({ message: "Only USD and/or BSD is allowed." })
      }
      return response
    })
  }

  async receiveMoney() {
    let session = this.storage.get('user.SessionID')
    let tx = this.storage.get('wu.tx.Body.esp-transaction-inquiry-reply')
    let receiveData = this.storage.get('wu.receive')
    let customer = this.storage.get('wu.customer')
    let data = {
      session,
      customerId: customer.id,
      mtcn: tx.money_transfer_control.mtcn,
      purpose: receiveData.purpose.description,
      source: receiveData.source.description,
      answer: receiveData.verifyAnswer
    }
    this.billDispenser.onDispensed().then(async () => {
      let tx_denominations = await this.billDispenser.getTxDenominations()
      this.api.ztrail(this.api.processParams(WU_END_POINT.RECEIVE_MONEY, data), { transaction_type: 'WITHDRAWAL', ...tx_denominations })
    })
    return this.api.mute().post(WU_END_POINT.RECEIVE_MONEY, data)
  }
}
